// Production API, and the auth proxy that forwards to it
export const API_BASE = 'https://intersportapi.netlify.app/.netlify/functions';
export const SHOPIFY_APP_PROXY_LOGIN_URL = 'https://function-bun-production-99a1.up.railway.app';
